import { useMutation } from 'react-query'
import { runSimulation } from 'utils/server/serverSTM2'

export const useSimulationQuery = () => {
  const [simulate] = useMutation(runSimulation)
  return simulate
}
